import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'

import { Hero } from '@/components/sections/hero'
import { Clients } from '@/components/sections/clients'
import { AboutStatement } from '@/components/sections/about-statement'
import { Results } from '@/components/sections/results'
import { Services } from '@/components/sections/services'
import { Comparison } from '@/components/sections/comparison'
import { Process } from '@/components/sections/process'
import { Testimonials } from '@/components/sections/testimonials'
import { Team } from '@/components/sections/team'
import { Faq } from '@/components/sections/faq'
import { Cta } from '@/components/sections/cta'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo description='Funnel is a paid advertising agency scaling brands with Meta, Google and TikTok ads. Ground-breaking growth, increased sales and higher profitability.' />

            <Hero />
            <Clients />
            <AboutStatement />
            <Results />
            <Services />
            <Comparison />
            <Process />
            <Testimonials />
            <Team />
            <Faq />
            <Cta />
        </Layout>
    )
}

export default Home
